<template>
  <div class="login-container">
    <img class="logo_img" src="../../public/logo.png" />
    <img class="BKG" src="../../public/bg.jpg" />
    <div class="left_text">
      <div class="h1">欢迎莅临 往圣科技</div>
      <div class="h2">为往圣继绝学，为万世开太平</div>
      <div class="h2">—往圣健康科技（广东）有限公司</div>
    </div>
    <div class="center-box">
      <div class="login-box">
        <!--   @click.stop="" TODO:容易点击到外面使input失去焦点 -->
        <div class="login-form">
          <div class="logo">
            <div>
              <span class="brand">WSKJ</span>
              <br />往圣科技管理系统
            </div>
          </div>
          <div class="title_l">登录!</div>
          <div v-if="isActive === 1">
            <el-input v-model="account" placeholder="手机号" class="account" maxlength="11" clearable></el-input>
            <div style="position: relative">
              <el-input v-model="verCode" placeholder="验证码" class="verCode" clearable></el-input>
              <el-button type="primary" class="getCode" @click="getCode" :disabled="disabled">
                {{ codeBtnTitle
                }}
              </el-button>
            </div>
          </div>

          <div v-else>
            <el-input
              v-model="account"
              placeholder="请输入账号"
              class="account"
              maxlength="11"
              clearable
              @keyup.enter.native="handleEnterAccount"
              @click.stop.native
            ></el-input>
            <el-input
              ref="password"
              placeholder="请输入密码"
              :type="flag ? 'text' : 'password'"
              v-model="password"
              maxlength="18"
              class="account"
              clearable
              @keyup.enter.native="handleEnter"
              @click.stop.native
            >
              <i
                slot="suffix"
                :class="[flag ? 'el-icon-sunny' : 'el-icon-cloudy']"
                class="password_icon"
                autocomplete="auto"
                @click="flag = !flag"
              />
            </el-input>
          </div>

          <div class="rememberBtn">
            <el-checkbox v-model="passwordChecked">记住{{ isActive === 0 ? "账号密码" : "手机号" }}</el-checkbox>
            <!-- <div class="link" @click="linkLogin">扫码登录</div> -->
          </div>

          <el-button
            type="primary"
            class="loginBtn"
            @click="loginBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
          >登录</el-button>

          <input @keyup.enter="handleEnter" ref="loginInput" class="loginInput" />
        </div>
      </div>

      <!-- 标语 -->
      <div class="life">
        <div class="h1">上海致善阔贤技术有限公司提供技术支持</div>
        <div class="h2">shzskx.cn Services Co., Ltd. provides technical support</div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../services/system/userServices";
import { mapActions } from "vuex";
export default {
  computed: {},
  created() {
    this.focusInput(); //自动聚焦到登录输入框
    //1记住密码  0不记住密码
    if (localStorage.getItem("passwordChecked") == 1) {
      this.passwordChecked = true;
      // 账号回显
      var loginForm = JSON.parse(localStorage.getItem("loginForm"));
      // console.log(loginForm);
      if (loginForm !== null) {
        this.account = loginForm.account;
        this.password = loginForm.password;
      }
    } else {
      this.passwordChecked = false;
    }
  },
  data() {
    return {
      flag: false,
      fullscreenLoading: false,
      account: "", //用户名或手机号
      verCode: "", //验证码
      password: "", //密码
      passwordChecked: "",
      codeBtnTitle: "验证码",
      disabled: false,
      loginStyle: ["账号登录", "手机号登录"],
      isActive: 0
    };
  },
  watch: {},
  methods: {
    focusInput() {
      //自动聚焦到登录输入框
      this.$nextTick(() => {
        this.$refs.loginInput.focus();
      });
    },
    handleEnterAccount(e) {
      if (e.keyCode === 13) {
        this.$refs.password.focus();
      }
    },
    handleEnter(e) {
      if (e.keyCode === 13) {
        this.loginBtn();
      }
    },
    activeBtn(i) {
      this.isActive = i;
    },
    /* 计时器 */
    timer() {
      let s = 60;
      this.codeBtnTitle = s + " s";
      this.disabled = true;
      let timer = setInterval(() => {
        s--;
        this.codeBtnTitle = s + " s";
        if (s === 0) {
          clearInterval(timer);
          this.codeBtnTitle = "验证码";
          this.disabled = false;
        }
      }, 1000);
    },
    /* 获取验证码 */
    getCode() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // console.log(reg_tel.test(this.account));
      if (!reg_tel.test(this.account)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
    },
    /* 登录 */
    loginBtn() {
      // var password = md5(this.password);
      var verCode = this.verCode;
      var password = this.password;
      var phoneNumber = this.account;
      // 记住密码监听
      if (this.passwordChecked) {
        //将用户数据存到localStorage 长期有效 （cooking不设置时效关闭浏览器就消失了 设置才长期有效）
        localStorage.setItem("passwordChecked", 1);
        var loginForm = {
          account: this.account,
          password: this.password
        };
        localStorage.setItem("loginForm", JSON.stringify(loginForm));
      } else {
        localStorage.setItem("passwordChecked", 0);
        localStorage.removeItem("loginForm");
      }

      if (this.isActive === 0) {
        if (phoneNumber === "" || password === "") {
          this.$message.error("账号或密码不能为空");
          return;
        }
      }
      if (this.isActive === 1) {
        if (phoneNumber === "" || verCode === "") {
          this.$message.error("手机号或验证码不能为空");
          return;
        }
      }
      this.fullscreenLoading = true;

      login(phoneNumber, password).then(res => {
        if (res.data.code == 200) {
          this.$store.commit("updateRole", res.data.data); //将用户数据存到vuex
          if (this.$store.state.supUser.roleId == 4) {
            this.fullscreenLoading = false;
            this.$message.info(
              "销售员无需登录后台，直接分享小程序二维码推广即可"
            );
            return;
          }
          setTimeout(() => {
            this.fullscreenLoading = false;
            this.$message.success(res.data.message);
            if (this.$store.state.supUser.roleId == 0) {
              this.$router.push({ name: "Admin" });
              localStorage.setItem("nextMenuActive", "/system/admin");
            } else if (this.$store.state.supUser.roleId == 1) {
              this.$router.push({ name: "MallOrder" });
              localStorage.setItem("nextMenuActive", "/mall/order");
            } else if (this.$store.state.supUser.roleId == 2) {
              this.$router.push({ name: "NiaojianOrganizationOrder" });
              localStorage.setItem(
                "nextMenuActive",
                "/niaojian/organizationOrder"
              );
            } else if (this.$store.state.supUser.roleId == 3) {
              this.$router.push({ name: "AnswersChatList" });
              localStorage.setItem("nextMenuActive", "/answers/chatList");
            } else if (this.$store.state.supUser.roleId == 5) {
              this.$router.push({ name: "AnswersChatList" });
              localStorage.setItem("nextMenuActive", "/answers/chatList");
            } else {
              this.$message.error("权限不足");
            }
          }, 1000);
        } else {
          this.$message.error(res.data.message);
          setTimeout(() => {
            this.fullscreenLoading = false;
          }, 1000);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  background: rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  position: fixed;

  .BKG {
    width: 100%;
    height: 100vh;
    // opacity: 0.2;
  }

  .center-box {
    height: 100vh;
    width: 50%;
    max-width: 1000px;
    min-width: 300px;
    position: absolute;
    right: 0;
    top: 0;
    animation-name: move;
    animation-duration: 2s;
    display: flex;
    background-color: #fff;
    box-shadow: 10px 10px 10px 20px rgba(216, 216, 216, 0.726);
    opacity: 0.9;
  }

  @keyframes move {
    from {
      opacity: 0;
      width: 0%;
    }

    to {
      opacity: 0.9;
      width: 50%;
    }
  }
}

/* 左边文字 */
.left_text {
  position: fixed;
  width: 35%;
  min-width: 300px;
  top: 33%;
  left: 8%;
  color: #fff;
  font-size: 20px;
  letter-spacing: 3px;
  // font-family: PingFangSC, PingFang SC;
  font-family: "楷体", "KaiTi", serif;
  .h1 {
    font-weight: 600;
    margin: 0 0 80px;
    font-size: 40px;
  }
  .h2 {
    margin: 30px 0;
  }
}

/* 右边登录 */
.login-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 30px;
  // box-shadow: 0 0 10px 0 rgba(88, 88, 88, 0.1);

  .login-form {
    position: absolute;
    top: 33%;
    width: 80%;
    margin: 0 auto;
    left: 0;
    right: 0;
    padding: 10px 30px;
    border-radius: 20px;

    .logo {
      position: absolute;
      top: -25%;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: flex;
      align-items: center;
      font-size: 1.2em;
      letter-spacing: 2px;
      font-weight: 800;
      height: 60px;
      text-align: center;
      justify-content: center;
    }

    .brand {
      font-size: 22px;
    }

    .title_l {
      margin: 20px 0;
      font-weight: 800;
      font-size: 1.2em;
    }

    .password_icon {
      position: absolute;
      font-size: 16px;
      right: 30px;
      top: 12.5px;
    }

    .password_icon:hover {
      cursor: pointer;
      color: #111111ca;
    }

    /* 登录方式切换 */
    .loginStyle {
      display: flex;
      width: 100%;
      margin: 10px auto;
      color: #6b6b6b;
    }

    .active {
      color: #afc7d6 !important;
      font-weight: 550;
    }

    .loginStyle > div {
      margin: 20px 15px 20px 0px;
    }

    .loginStyle > div:hover {
      cursor: pointer;
    }

    .account {
      margin: 20px auto;
      width: 100%;
      display: block;
      position: relative;
    }

    .verCode {
      display: block;
      margin: 10px auto;
      width: 100%;
    }

    .getCode {
      position: absolute;
      top: 0px;
      right: 10%;
      width: 85px;
    }

    .rememberBtn {
      margin: 0 auto;
      width: 100%;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #12c2e9 !important;
      border-color: #12c2e9 !important;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #12c2e9;
    }

    .loginBtn {
      background: linear-gradient(to right, #12c2e9, #71ed7d);
      margin: 20px auto;
      width: 100%;
      display: block;
      border: none;
    }
  }
}

.life {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  text-align: center;
  font-weight: 200;

  .footer {
    letter-spacing: 3px;
    color: #7f7f7f;
  }
}

.logo_img {
  position: fixed;
  top: 30px;
  left: 50px;
  width: 80px;
}

/* 回车输入框 */
.loginInput {
  position: fixed;
  opacity: 0;
  right: 0;
  bottom: 0;
}
</style>
